import { render, staticRenderFns } from "./FilterContainerBox.vue?vue&type=template&id=9474ce64&"
import script from "./FilterContainerBox.vue?vue&type=script&lang=ts&"
export * from "./FilterContainerBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports